import { init, trackEvent } from "@aptabase/web";
import { App } from "@capacitor/app";
import { Capacitor } from "@capacitor/core";

export async function initAnalytics() {
  // App.getInfo() is not implemented on web, and the SDK's own debug
  // detection treats the Capacitor webview (localhost) as debug.
  let appVersion = "";
  if (Capacitor.isNativePlatform()) {
    appVersion = (await App.getInfo()).version;
  }

  init("A-SH-6666106318", {
    host: "https://analytics.cityrights.app",
    appVersion,
    isDebug: process.env.NODE_ENV === "development",
  });
}

export { trackEvent };
